import React from "react";
import PropTypes from "prop-types";
import AttendanceActionsMenu from "./AttendanceActionsMenu";

function AttendanceLessonHeader({ canUndoWholeLessonCancellation, viewModel, onAction }) {
  const lessonTime = viewModel.endTime
    ? `${viewModel.lessonDetails.startTime}-${viewModel.endTime}`
    : viewModel.lessonDetails.startTime;

  return (
    <>
      <h2 className="attendance-page__title">{viewModel.title}</h2>
      <div className="attendance-page__context">
        <div className="attendance-page__context-item attendance-page__context-item--time">
          <span className="attendance-page__context-icon" aria-hidden="true">
            <i className="far fa-clock" />
          </span>
          <div>
            <span>Godzina</span>
            <strong>{lessonTime}</strong>
          </div>
        </div>
        <div>
          <span>Lektor</span>
          <strong>{viewModel.teacherName}</strong>
        </div>
        {viewModel.schoolClass.comment && (
          <div>
            <span>Sala / Uwagi</span>
            <strong>{viewModel.schoolClass.comment}</strong>
          </div>
        )}
        <div>
          <span>Poziom / Kurs</span>
          <strong>{viewModel.classTypeName}</strong>
        </div>
        <AttendanceActionsMenu
          canUndoWholeLessonCancellation={canUndoWholeLessonCancellation}
          onAction={onAction}
        />
      </div>
    </>
  );
}

AttendanceLessonHeader.propTypes = {
  canUndoWholeLessonCancellation: PropTypes.bool,
  viewModel: PropTypes.object.isRequired,
  onAction: PropTypes.func.isRequired,
};

AttendanceLessonHeader.defaultProps = {
  canUndoWholeLessonCancellation: false,
};

export default AttendanceLessonHeader;
